export default __webpack_public_path__ + "static/media/dashboard_wait_update.f5a0f3c5.svg";